import styled from "styled-components/macro";

import { ContainerLogin } from "../../../components/containers";

export const UserTypeStep = styled(ContainerLogin)`
  max-width: 800px;

  @media (max-width: 500px) {
    max-width: 336px;
  }
`;

export const FormContainer = styled(ContainerLogin)`
  position: relative;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const GoBackButton = styled.div`
  position: absolute;
  left: -30px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    svg {
      path {
        fill: ${(p) => p.theme.colors.primary};
      }
    }
  }
`;

export const RegisterTitle = styled.div`
  position: relative;
  font-size: ${({ theme }) => theme.font.size};
  font-family: ${({ theme }) => theme.text.family};
  line-height: ${({ theme }) => theme.text.defaultLineHeight};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.hardGray};
  margin-bottom: 16px;
`;
